import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';

@Component({
  selector: 'app-traitement-data-epap-ipap',
  standalone: true,
  imports: [TraitementDataComponent, ALaDateDuPipe],
  templateUrl: './traitement-data-epap-ipap.component.html',
  styleUrl: './traitement-data-epap-ipap.component.scss'
})
export class TraitementDataEpapIpapComponent {
  @Input() patient: Patient | undefined;

}
